import React, { useEffect, useState, useMemo } from "react";
import { api } from "../../../utils/api";

// UI Components
import VisaCategory from "@/components/ui/visaCategory";
import VisaType from "@/components/ui/visaTypes";
import VisaPurpose from "@/components/ui/VisaPurpose";
import Stepper from "@/components/ui/Stepper";
import PassengerNameForm from "@/components/ui/application/PassengerNameForm";
import PassengerDocuments from "@/components/ui/application/PassengerDocuments";

// Layout
import UserLayout from "@/components/UserLayout";

// Loader
import AIMagicLoader from "@/components/AIMagicLoader.jsx";

// Utility functions
import { resolveFormConfig } from "@/pages/user/forms/utils/resolveFormConfig";
import { mapExtractedData } from "@/pages/user/forms/utils/Datamapper";

// Form Renderer
import FormRenderer from "@/pages/user/forms/renderer/FormRenderer";

// Payload Builder
import { buildSubmitPayload } from "../forms/utils/buildSubmitPayload";
import { CheckCircle2 } from "lucide-react";

import { useNavigate } from "react-router-dom";

// function CreateNewApplication() {
//   // ----------------------------------------------------------------------------
//   // Loader State
//   // ----------------------------------------------------------------------------
//   const [showLoader, setShowLoader] = useState(false);
//   const [loaderDone, setLoaderDone] = useState(false);

//   // ----------------------------------------------------------------------------
//   // Stepper Control
//   // ----------------------------------------------------------------------------
//   const [currentStep, setCurrentStep] = useState("selection");

//   // ----------------------------------------------------------------------------
//   // Visa Master Data
//   // ----------------------------------------------------------------------------
//   const [visaCategories, setVisaCategories] = useState([]);

//   // All dropdowns
//   const [nationality, setNationality] = useState([]);
//   const [portOfEntry, setPortOfEntry] = useState([]);
//   const [portOfExit, setPortOfExit] = useState([]);
//   const [previousNationalities, setPreviousNationalities] = useState([]);
//   const [otherNationalities, setOtherNationalities] = useState([]);
//   const [country, setCountries] = useState([]);

//   // ----------------------------------------------------------------------------
//   // User Selections
//   // ----------------------------------------------------------------------------
//   const [selectedCategory, setSelectedCategory] = useState("");
//   const [selectedVisaType, setSelectedVisaType] = useState(null);
//   const [selectedPurpose, setSelectedPurpose] = useState(null);

//   // ----------------------------------------------------------------------------
//   // Documents
//   // ----------------------------------------------------------------------------
//   const [documents, setDocuments] = useState([]);

//   // ----------------------------------------------------------------------------
//   // Passenger Management
//   // ----------------------------------------------------------------------------
//   const [numPassengers, setNumPassengers] = useState(1);
//   const [currentPassengerIndex, setCurrentPassengerIndex] = useState(1);

//   // ----------------------------------------------------------------------------
//   // Passenger Data
//   // ----------------------------------------------------------------------------
//   const [passengerData, setPassengerData] = useState({
//     fullName: "",
//   });

//   // ----------------------------------------------------------------------------
//   // Data Extraction State
//   // ----------------------------------------------------------------------------
//   const [extracting, setExtracting] = useState(false);
//   const [applicationId, setApplicationId] = useState(null);
//   const [dataExtracted, setDataExtracted] = useState(false);
//   const [extractedCount, setExtractedCount] = useState(0);
//   const [extractedFormData, setExtractedFormData] = useState({});

//   // ----------------------------------------------------------------------------
//   // Form Values
//   // ----------------------------------------------------------------------------
//   const [formValues, setFormValues] = useState({});

//   // ============================================================================
//   // STEPPER CONFIGURATION
//   // ============================================================================
//   const STEPS = [
//     { key: "selection", label: "Visa Type" },
//     { key: "count", label: "Number of Passengers" },
//     { key: "details", label: "Passenger Details" },
//     // { key: "documents", label: "Documents" },
//     { key: "form", label: "Form" },
//     { key: "review", label: "Review Your Application" },
//     { key: "success", label: "Completed" },
//   ];





//   // ============================================================================
//   // LIFECYCLE: FETCH VISA CATEGORIES ON MOUNT
//   // ============================================================================
//   useEffect(() => {
//     fetchVisaCategories();
//     fetchAll();
//   }, []);

//   /**
//    * Fetches available visa categories from the API
//    */
//   const fetchVisaCategories = async () => {
//     try {
//       const response = await api.getVisaTypes();
//       setVisaCategories(response.data);
//     } catch (error) {
//       console.error("Error fetching visa categories:", error);
//     }
//   };

//   const fetchAll = async () => {
//     try {
//       const response = await api.getAlldropdowns();
//       setNationality(response.data.nationalities);
//       setPortOfEntry(response.data.port_of_entry);
//       setPortOfExit(response.data.port_of_exit);
//       setPreviousNationalities(response.data.previous_nationalities);
//       setOtherNationalities(response.data.other_nationalities);
//       setCountries(response.data.country_of_birth);

//     } catch (error) {
//       console.error("Error fetching visa categories:", error);
//     }
//   };



//   // ============================================================================
//   // DERIVED DATA (MEMOIZED FOR PERFORMANCE)
//   // ============================================================================

//   /**
//    * Extract only category names from visa categories
//    */
//   const categories = useMemo(() => {
//     return visaCategories.map((item) => item.category);
//   }, [visaCategories]);

//   /**
//    * Get full object of selected category
//    */
//   const selectedCategoryData = useMemo(() => {
//     return visaCategories.find((item) => item.category === selectedCategory);
//   }, [visaCategories, selectedCategory]);

//   /**
//    * Visa types available for the selected category
//    */
//   const visaTypes = useMemo(() => {
//     return selectedCategoryData?.visa_types || [];
//   }, [selectedCategoryData]);

//   /**
//    * Purposes available for the selected category
//    */
//   const purposes = useMemo(() => {
//     return selectedCategoryData?.purposes || [];
//   }, [selectedCategoryData]);

//   // ============================================================================
//   // SIDE EFFECT: FETCH DOCUMENTS BASED ON VISA TYPE
//   // ============================================================================
//   useEffect(() => {
//     // Clear documents if no visa type is selected
//     if (!selectedVisaType?.id) {
//       setDocuments([]);
//       console.log("No visa type selected, documents cleared.");
//       return;
//     }

//     /**
//      * Fetches required documents for the selected visa type
//      */
//     const fetchDocuments = async () => {
//       try {
//         const response = await api.getVisaTypeDocuments(selectedVisaType.id);
//         setDocuments(response.data || []);
//       } catch (error) {
//         console.error("Failed to fetch documents:", error);
//         setDocuments([]);
//       }
//     };

//     fetchDocuments();
//   }, [selectedVisaType]);

//   // ============================================================================
//   // VALIDATION: CHECK IF USER CAN PROCEED FROM SELECTION STEP
//   // ============================================================================
//   const canProceed = Boolean(
//     selectedCategory && selectedVisaType && selectedPurpose,
//   );

//   // ============================================================================
//   // UTILITY: BUILD FORM DATA FOR BULK DOCUMENT UPLOAD
//   // ============================================================================
//   /**
//    * Constructs FormData for bulk document upload
//    *
//    * @param {string} applicationId - The application ID
//    * @param {Object} uploadedFiles - Object mapping document_type_id to file
//    * @returns {FormData} - FormData ready for upload
//    */
//   const buildBulkUploadFormData = (applicationId, uploadedFiles) => {
//     const formData = new FormData();

//     // Append application ID
//     formData.append("application_id", applicationId);

//     // Append document type IDs and files in the same order
//     Object.entries(uploadedFiles).forEach(([documentTypeId, file]) => {
//       formData.append("document_type_ids", documentTypeId);
//       formData.append("files", file);
//     });

//     return formData;
//   };

//   // ============================================================================
//   // UTILITY: RESOLVE FORM CONFIGURATION
//   // ============================================================================
//   /**
//    * Resolves the appropriate form configuration based on category and purpose
//    */
//   const formConfig = resolveFormConfig(
//     selectedCategory,
//     selectedPurpose?.purpose_code,
//   );

//   // ============================================================================
//   // HANDLER: DOCUMENT EXTRACTION AND AI PROCESSING
//   // ============================================================================
//   /**
//    * Handles the document extraction process:
//    * 1. Creates a new application
//    * 2. Uploads documents
//    * 3. Extracts data using AI
//    * 4. Maps extracted data to form fields
//    *
//    * @param {Object} uploadedFiles - Object mapping document_type_id to file
//    */
//   const handleExtract = async (uploadedFiles) => {
//     try {
//       setExtracting(true);
//       setShowLoader(true);
//       setLoaderDone(false);

//       // STEP 1: Create application
//       const payload = {
//         visa_type_id: selectedVisaType.id,
//         purpose_code: selectedPurpose.purpose_code,
//         num_passengers: 1,
//       };

//       const appRes = await api.createApplication(payload);
//       const appId = appRes.data?.id || appRes.data?.application_id;

//       if (!appId) {
//         throw new Error("Application ID not received");
//       }

//       setApplicationId(appId);

//       // STEP 2: Upload documents
//       const formData = buildBulkUploadFormData(appId, uploadedFiles);
//       await api.uploadApplicationDocuments(formData);

//       // STEP 3: Extract data from documents using AI
//       const extractRes = await api.extractAndMapDocuments(appId);
//       const mappedData = extractRes.data?.mapped || {};

//       // STEP 4: Map extracted data to form fields
//       const autoFilledValues = mapExtractedData(mappedData, formConfig);

//       setExtractedFormData(autoFilledValues);

//       // Count how many fields were successfully extracted
//       setExtractedCount(
//         Object.values(autoFilledValues).filter(Boolean).length
//       );

//       setDataExtracted(true);
//       setLoaderDone(true);
//       setCurrentStep("form");
//     } catch (error) {
//       console.error("Document extraction error:", error);
//       alert("Failed to process documents. Please retry.");
//     } finally {
//       setExtracting(false);
//     }
//   };

//   // const handleExtract = async (uploadedFiles) => {
//   //   try {
//   //     setExtracting(true);
//   //     setShowLoader(true);
//   //     setLoaderDone(false);

//   //     // STEP 1: Create application
//   //     const payload = {
//   //       visa_type_id: selectedVisaType.id,
//   //       purpose_code: selectedPurpose.purpose_code,
//   //       num_passengers: 1,
//   //     };

//   //     const appRes = await api.createApplication(payload);
//   //     const appId = appRes.data?.id || appRes.data?.application_id;

//   //     if (!appId) {
//   //       throw new Error("Application ID not received");
//   //     }

//   //     setApplicationId(appId);

//   //     // STEP 2: Upload documents
//   //     const formData = buildBulkUploadFormData(appId, uploadedFiles);
//   //     await api.uploadApplicationDocuments(formData);

//   //     // STEP 3: Extract data from documents using AI
//   //     const extractRes = await api.extractAndMapDocuments(appId);
//   //     const mappedData = extractRes.data?.mapped || {};

//   //     // STEP 4: Map extracted data to form fields
//   //     const autoFilledValues = mapExtractedData(mappedData, formConfig);

//   //     setExtractedFormData(autoFilledValues);

//   //     // Count how many fields were successfully extracted
//   //     setExtractedCount(Object.values(autoFilledValues).filter(Boolean).length);

//   //     setDataExtracted(true);
//   //     setLoaderDone(true);
//   //     setCurrentStep("form");
//   //   } catch (error) {
//   //     console.error("Document extraction error:", error);
//   //     alert("Failed to process documents. Please retry.");
//   //   } finally {
//   //     setExtracting(false);
//   //   }
//   // };

//   // ============================================================================
//   // HANDLER: NAVIGATE TO REVIEW STEP
//   // ============================================================================
//   /**
//    * Called when user clicks Review button after filling the form
//    *
//    * @param {Object} values - Form values to review
//    */
//   const handleReview = (values) => {
//     setFormValues(values);
//     setCurrentStep("review");
//   };

//   // ============================================================================
//   // HANDLER: FINAL FORM SUBMISSION
//   // ============================================================================
//   /**
//    * Submits the final application with all form data
//    */
//   const handleFinalSubmit = async () => {
//     try {
//       const payload = buildSubmitPayload(formValues);
//       console.log("Final Payload:", payload);

//       await api.updateApplication(applicationId, payload);

//       setCurrentStep("success");
//     } catch (error) {
//       console.error("Submission error:", error);
//       alert("Failed to submit application. Please try again.");
//     }
//   };

//   // ============================================================================
//   // RENDER
//   // ============================================================================
//   return (
//     <UserLayout>
//       <div className="h-60vh bg-slate-50 p-4">
//         <div className="max-w-10xl mx-auto bg-white border rounded-xl p-6">
//           {/* Stepper - Shows progress through application steps */}
//           <Stepper steps={STEPS} currentStep={currentStep} />

//           {/* ================================================================
//               STEP 1-3: VISA SELECTION (Category → Type → Purpose)
//           ================================================================ */}
//           {currentStep === "selection" && (
//             <>
//               {/* Visa Category Selection */}
//               <VisaCategory
//                 categories={categories}
//                 selectedCategory={selectedCategory}
//                 onSelectCategory={(cat) => {
//                   setSelectedCategory(cat);
//                   setSelectedVisaType(null);
//                   setSelectedPurpose(null);
//                 }}
//               />

//               {/* Visa Type Selection (shown after category is selected) */}
//               {selectedCategory && (
//                 <div className="mt-10">
//                   <VisaType
//                     visaTypes={visaTypes}
//                     selectedVisaType={selectedVisaType}
//                     onSelectVisaType={(type) => {
//                       setSelectedVisaType(type);
//                       setSelectedPurpose(null);
//                     }}
//                   />
//                 </div>
//               )}

//               {/* Visa Purpose Selection (shown after type is selected) */}
//               {selectedVisaType && (
//                 <div className="mt-10">
//                   <VisaPurpose
//                     purposes={purposes}
//                     selectedPurpose={selectedPurpose}
//                     onSelectPurpose={setSelectedPurpose}
//                   />
//                 </div>
//               )}

//               {/* Next Button (enabled only when all selections are made) */}
//               {canProceed && (
//                 <div className="mt-8 flex justify-end">
//                   <button
//                     type="button"
//                     onClick={() => setCurrentStep("count")}
//                     // onClick={() => setCurrentStep("form")}
//                     className="px-6 py-3 rounded-xl bg-blue-600 text-white font-semibold hover:bg-blue-700 transition"
//                   >
//                     Next
//                   </button>
//                 </div>
//               )}
//             </>
//           )}

//           {/* ================================================================
//               STEP 4: NUMBER OF PASSENGERS
//           ================================================================ */}
//           {currentStep === "count" && (
//             <div className="space-y-4">
//               {/* Header */}
//               <h3 className="text-lg font-semibold text-gray-900">
//                 Step 4: Number of Passengers
//               </h3>

//               {/* Input Section */}
//               <div className="max-w-md space-y-4">
//                 <label className="block text-sm font-medium text-gray-700">
//                   How many passengers?{" "}
//                   <span className="text-gray-400">(1–50)</span>
//                 </label>

//                 <input
//                   type="number"
//                   min={1}
//                   max={50}
//                   value={numPassengers}
//                   onChange={(e) => {
//                     // Ensure value stays within bounds
//                     const value = Math.max(
//                       1,
//                       Math.min(50, Number(e.target.value)),
//                     );
//                     setNumPassengers(value);
//                     // Adjust current passenger index if needed
//                     setCurrentPassengerIndex((prev) => Math.min(prev, value));
//                   }}
//                   className="w-40 px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 text-gray-900"
//                 />

//                 <p className="text-sm text-gray-600">
//                   Each passenger will have a separate application.
//                 </p>
//               </div>

//               {/* Navigation Buttons */}
//               <div className="flex items-center justify-between">
//                 <button
//                   type="button"
//                   onClick={() => setCurrentStep("selection")}
//                   className="px-6 py-3 rounded-xl border border-gray-300 text-gray-700 font-medium hover:bg-gray-50 transition"
//                 >
//                   ← Back
//                 </button>

//                 <button
//                   type="button"
//                   onClick={() => {
//                     setCurrentPassengerIndex(1);
//                     setCurrentStep("details");
//                   }}
//                   className="px-8 py-3 rounded-xl bg-blue-600 text-white font-semibold hover:bg-blue-700 transition"
//                 >
//                   Next →
//                 </button>
//               </div>
//             </div>
//           )}

//           {/* ================================================================
//               STEP 5: PASSENGER DETAILS
//           ================================================================ */}
//           {currentStep === "details" && (
//             <div className="space-y-5">
//               {/* Header */}
//               <h3 className="text-lg font-bold text-gray-900 mb-2">
//                 Step 5: Passenger Details
//               </h3>
//               <p className="text-sm text-gray-600">
//                 Passenger {currentPassengerIndex} of {numPassengers}
//               </p>

//               {/* Passenger Name Form */}
//               <PassengerNameForm
//                 fullName={passengerData.fullName}
//                 onChange={(value) =>
//                   setPassengerData({ ...passengerData, fullName: value })
//                 }
//               />

//               {/* Document Upload with AI Extraction */}
//               <PassengerDocuments
//                 documents={documents}
//                 passengerName={passengerData.fullName}
//                 onExtract={handleExtract}
//                 loading={extracting}
//                 dataExtracted={dataExtracted}
//                 extractedCount={extractedCount}
//               />

//               {/* Navigation */}
//               <div className="border-t pt-8 flex items-center justify-between">
//                 <button
//                   type="button"
//                   onClick={() => setCurrentStep("count")}
//                   className="px-6 py-3 rounded-xl border border-gray-300 text-gray-700 font-medium hover:bg-gray-50 transition"
//                 >
//                   ← Back
//                 </button>
//               </div>
//             </div>
//           )}

//           {/* ================================================================
//               STEP 6: FORM RENDERING (with AI-extracted data)
//           ================================================================ */}
//           {/* {currentStep === "form" && (
//             <FormRenderer
//               config={formConfig}
//               initialValues={extractedFormData}
//               onSubmit={handleReview}
//               nationality={nationality}
//               portOfEntry={portOfEntry}
//               portOfExit={portOfExit}
//               previousNationalities={previousNationalities}
//               otherNationalities={otherNationalities}
//               country={country}
//             />
//           )} */}
//           {currentStep === "form" && (
//             <FormRenderer
//               config={formConfig}
//               initialValues={extractedFormData}
//               onSubmit={handleReview}
//               mode="edit"
//               nationality={nationality}
//               portOfEntry={portOfEntry}
//               portOfExit={portOfExit}
//               previousNationalities={previousNationalities}
//               otherNationalities={otherNationalities}
//               country={country}
//             />
//           )}

//           {/* ================================================================
//               STEP 7: REVIEW APPLICATION
//           ================================================================ */}
//           {/* {currentStep === "review" && (
//             <ReviewApplication
//               config={formConfig}
//               values={formValues}
//               onEdit={() => setCurrentStep("form")}
//               onSubmit={handleFinalSubmit}
//             />
//           )} */}

//           {currentStep === "review" && (
//             <FormRenderer
//               config={formConfig}
//               initialValues={formValues}
//               onSubmit={handleFinalSubmit}
//               onEdit={() => setCurrentStep("form")}
//               mode="review"
//               nationality={nationality}
//               portOfEntry={portOfEntry}
//               portOfExit={portOfExit}
//               previousNationalities={previousNationalities}
//               otherNationalities={otherNationalities}
//               country={country}
//             />
//           )}

//           {/* ================================================================
//               AI MAGIC LOADER (shown during document extraction)
//           ================================================================ */}
//           {showLoader && (
//             <AIMagicLoader
//               isDone={loaderDone}
//               extractedCount={extractedCount}
//               onClose={() => setShowLoader(false)}
//             />
//           )}
//         </div>
//       </div>
//     </UserLayout>
//   );
// }

// export default CreateNewApplication;


// function CreateNewApplication() {
//   const navigate = useNavigate();

//   const [showLoader, setShowLoader] = useState(false);
//   const [loaderDone, setLoaderDone] = useState(false);
//   const [currentStep, setCurrentStep] = useState("selection");

//   // Visa Master Data
//   const [visaCategories, setVisaCategories] = useState([]);
//   const [nationality, setNationality] = useState([]);
//   const [portOfEntry, setPortOfEntry] = useState([]);
//   const [portOfExit, setPortOfExit] = useState([]);
//   const [previousNationalities, setPreviousNationalities] = useState([]);
//   const [otherNationalities, setOtherNationalities] = useState([]);
//   const [country, setCountries] = useState([]);

//   // User Selections
//   const [selectedCategory, setSelectedCategory] = useState("");
//   const [selectedVisaType, setSelectedVisaType] = useState(null);
//   const [selectedPurpose, setSelectedPurpose] = useState(null);

//   // Documents
//   const [documents, setDocuments] = useState([]);

//   // Passenger Management
//   const [numPassengers, setNumPassengers] = useState(1);
//   const [currentPassengerIndex, setCurrentPassengerIndex] = useState(1);
//   const [passengerData, setPassengerData] = useState({ fullName: "" });

//   // Data Extraction
//   const [extracting, setExtracting] = useState(false);
//   const [applicationId, setApplicationId] = useState(null);
//   const [dataExtracted, setDataExtracted] = useState(false);
//   const [extractedCount, setExtractedCount] = useState(0);
//   const [extractedFormData, setExtractedFormData] = useState({});

//   // Form Values
//   const [formValues, setFormValues] = useState({});

//   // Edit & Submission State
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [hasEditedOnce, setHasEditedOnce] = useState(false);
//   const [isSaving, setIsSaving] = useState(false);
//   const [isSubmitted, setIsSubmitted] = useState(false);

//   //Consent checkbox state
//   const [consentGiven, setConsentGiven] = useState(false);

//   // STEPPER CONFIGURATION
//   const STEPS = [
//     { key: "selection", label: "Visa Type" },
//     { key: "count", label: "Number of Passengers" },
//     { key: "details", label: "Passenger Details" },
//     { key: "form", label: "Form" },
//     { key: "review", label: "Review Your Application" },
//     { key: "submit", label: "Submit" },
//   ];

//   useEffect(() => {
//     fetchVisaCategories();
//     fetchAll();
//   }, []);

//   const fetchVisaCategories = async () => {
//     try {
//       const response = await api.getVisaTypes();
//       setVisaCategories(response.data);
//     } catch (error) {
//       console.error("Error fetching visa categories:", error);
//     }
//   };

//   const fetchAll = async () => {
//     try {
//       const response = await api.getAlldropdowns();
//       setNationality(response.data.nationalities);
//       setPortOfEntry(response.data.port_of_entry);
//       setPortOfExit(response.data.port_of_exit);
//       setPreviousNationalities(response.data.previous_nationalities);
//       setOtherNationalities(response.data.other_nationalities);
//       setCountries(response.data.country_of_birth);
//     } catch (error) {
//       console.error("Error fetching dropdowns:", error);
//     }
//   };

//   useEffect(() => {
//     if (!selectedVisaType?.id) {
//       setDocuments([]);
//       return;
//     }

//     const fetchDocuments = async () => {
//       try {
//         const response = await api.getVisaTypeDocuments(selectedVisaType.id);
//         setDocuments(response.data || []);
//       } catch (error) {
//         console.error("Failed to fetch documents:", error);
//         setDocuments([]);
//       }
//     };

//     fetchDocuments();
//   }, [selectedVisaType]);

//   // ... (keep all your existing useMemo declarations) ...

//   const categories = useMemo(() => {
//     return visaCategories.map((item) => item.category);
//   }, [visaCategories]);

//   const selectedCategoryData = useMemo(() => {
//     return visaCategories.find((item) => item.category === selectedCategory);
//   }, [visaCategories, selectedCategory]);

//   const visaTypes = useMemo(() => {
//     return selectedCategoryData?.visa_types || [];
//   }, [selectedCategoryData]);

//   const purposes = useMemo(() => {
//     return selectedCategoryData?.purposes || [];
//   }, [selectedCategoryData]);

//   const canProceed = Boolean(
//     selectedCategory && selectedVisaType && selectedPurpose
//   );

//   const formConfig = resolveFormConfig(
//     selectedCategory,
//     selectedPurpose?.purpose_code
//   );

//   const dropdownData = {
//     nationality,
//     port_of_entry: portOfEntry,
//     port_of_exit: portOfExit,
//     previous_nationalities: previousNationalities,
//     other_passport_nationality: otherNationalities,
//     country_of_birth: country,
//   };

//   // ... (keep all your existing handler functions) ...

//   const buildBulkUploadFormData = (applicationId, uploadedFiles) => {
//     const formData = new FormData();
//     formData.append("application_id", applicationId);

//     Object.entries(uploadedFiles).forEach(([documentTypeId, file]) => {
//       formData.append("document_type_ids", documentTypeId);
//       formData.append("files", file);
//     });

//     return formData;
//   };

//   const handleExtract = async (uploadedFiles) => {
//     try {
//       setExtracting(true);
//       setShowLoader(true);
//       setLoaderDone(false);

//       // STEP 1: Create application
//       const payload = {
//         visa_type_id: selectedVisaType.id,
//         purpose_code: selectedPurpose.purpose_code,
//         num_passengers: 1,
//       };

//       const appRes = await api.createApplication(payload);
//       const appId = appRes.data?.id || appRes.data?.application_id;

//       if (!appId) {
//         throw new Error("Application ID not received");
//       }

//       setApplicationId(appId);

//       // STEP 2: Upload documents
//       const formData = buildBulkUploadFormData(appId, uploadedFiles);
//       await api.uploadApplicationDocuments(formData);

//       // STEP 3: Extract data from documents using AI
//       const extractRes = await api.extractAndMapDocuments(appId);
//       const mappedData = extractRes.data?.mapped || {};

//       // STEP 4: Map extracted data to form fields
//       const autoFilledValues = mapExtractedData(mappedData, formConfig);

//       setExtractedFormData(autoFilledValues);

//       // Count how many fields were successfully extracted
//       setExtractedCount(
//         Object.values(autoFilledValues).filter(Boolean).length
//       );

//       setDataExtracted(true);
//       setLoaderDone(true);
//       setCurrentStep("form");
//     } catch (error) {
//       console.error("Document extraction error:", error);
//       alert("Failed to process documents. Please retry.");
//     } finally {
//       setExtracting(false);
//     }
//   };

//   const handleSaveFormData = async (values) => {
//     if (!applicationId) return;

//     try {
//       setIsSaving(true);

//       const payload = buildSubmitPayload(values);
//       await api.updateApplication(applicationId, payload);

//       setFormValues(values);
//     } catch (error) {
//       console.error("Failed to save form data:", error);
//       alert("Failed to save data. Please try again.");
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   const handleMoveToReview = async (values) => {
//     await handleSaveFormData(values);
//     setCurrentStep("review");
//   };

//   const handleEnableEdit = () => {
//     if (hasEditedOnce) {
//       alert("You have already used your one-time edit.");
//       return;
//     }

//     setIsEditMode(true);
//     setHasEditedOnce(true);
//     setCurrentStep("form");
//   };


//   const handleFinalSubmit = async () => {
//     try {
//       setIsSaving(true);

//       const payload = buildSubmitPayload(formValues);
//       await api.updateApplication(applicationId, payload);

//       // Move to submission summary screen
//       setIsSubmitted(true);
//       setCurrentStep("submit");
//     } catch (error) {
//       console.error("Submission error:", error);
//       alert("Failed to prepare submission.");
//     } finally {
//       setIsSaving(false);
//     }
//   };


//   const handleFinalApplicationSubmit = async () => {
//     if (!consentGiven) {
//       alert("Please accept the declaration to proceed.");
//       return;
//     }

//     try {
//       setIsSaving(true);

//       // Final submission API call with status
//       const payload = {
//         ...buildSubmitPayload(formValues),
//         status: "Application Received, Pending for Review",
//         consent_given: true,

//       };

//       await api.updateApplication(applicationId, payload);

//       alert("Application submitted successfully!");

//       // Optionally redirect to dashboard or applications list
//       navigate('/dashboard');
//     } catch (error) {
//       console.error("Final submission error:", error);
//       alert("Failed to submit application.");
//     } finally {
//       setIsSaving(false);
//     }
//   };


//   return (
//     <UserLayout>
//       <div className="min-h-screen bg-slate-50 p-4">
//         <div className="max-w-7xl mx-auto bg-white border rounded-xl p-6">

//           <Stepper steps={STEPS} currentStep={currentStep} />

//           {/* Saving indicator */}
//           {isSaving && (
//             <div className="mb-4 text-sm text-blue-600 flex items-center gap-2">
//               <div className="animate-spin h-4 w-4 border-2 border-blue-600 border-t-transparent rounded-full"></div>
//               Saving...
//             </div>
//           )}

//           {/* ================================================================
//               STEP 1: VISA SELECTION
//           ================================================================ */}
//           {currentStep === "selection" && (
//             <>
//               <VisaCategory
//                 categories={categories}
//                 selectedCategory={selectedCategory}
//                 onSelectCategory={(cat) => {
//                   setSelectedCategory(cat);
//                   setSelectedVisaType(null);
//                   setSelectedPurpose(null);
//                 }}
//               />

//               {selectedCategory && (
//                 <div className="mt-10">
//                   <VisaType
//                     visaTypes={visaTypes}
//                     selectedVisaType={selectedVisaType}
//                     onSelectVisaType={(type) => {
//                       setSelectedVisaType(type);
//                       setSelectedPurpose(null);
//                     }}
//                   />
//                 </div>
//               )}

//               {selectedVisaType && (
//                 <div className="mt-10">
//                   <VisaPurpose
//                     purposes={purposes}
//                     selectedPurpose={selectedPurpose}
//                     onSelectPurpose={setSelectedPurpose}
//                   />
//                 </div>
//               )}

//               {canProceed && (
//                 <div className="mt-8 flex justify-end">
//                   <button
//                     type="button"
//                     onClick={() => setCurrentStep("count")}
//                     className="px-6 py-3 rounded-xl bg-blue-600 text-white font-semibold hover:bg-blue-700"
//                   >
//                     Next
//                   </button>
//                 </div>
//               )}
//             </>
//           )}

//           {/* ================================================================
//               STEP 2: NUMBER OF PASSENGERS
//           ================================================================ */}
//           {currentStep === "count" && (
//             <div className="space-y-4">
//               <h3 className="text-lg font-semibold text-gray-900">
//                 Number of Passengers
//               </h3>

//               <div className="max-w-md space-y-4">
//                 <label className="block text-sm font-medium text-gray-700">
//                   How many passengers? <span className="text-gray-400">(1–50)</span>
//                 </label>

//                 <input
//                   type="number"
//                   min={1}
//                   max={50}
//                   value={numPassengers}
//                   onChange={(e) => {
//                     const value = Math.max(1, Math.min(50, Number(e.target.value)));
//                     setNumPassengers(value);
//                     setCurrentPassengerIndex((prev) => Math.min(prev, value));
//                   }}
//                   className="w-40 px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 text-gray-900"
//                 />

//                 <p className="text-sm text-gray-600">
//                   Each passenger will have a separate application.
//                 </p>
//               </div>

//               <div className="flex items-center justify-between pt-6">
//                 <button
//                   type="button"
//                   onClick={() => setCurrentStep("selection")}
//                   className="px-6 py-3 rounded-xl border border-gray-300 text-gray-700 font-medium hover:bg-gray-50"
//                 >
//                   ← Back
//                 </button>

//                 <button
//                   type="button"
//                   onClick={() => {
//                     setCurrentPassengerIndex(1);
//                     setCurrentStep("details");
//                   }}
//                   className="px-8 py-3 rounded-xl bg-blue-600 text-white font-semibold hover:bg-blue-700"
//                 >
//                   Next →
//                 </button>
//               </div>
//             </div>
//           )}

//           {/* ================================================================
//               STEP 3: PASSENGER DETAILS
//           ================================================================ */}
//           {currentStep === "details" && (
//             <div className="space-y-5">
//               <h3 className="text-lg font-bold text-gray-900 mb-2">
//                 Passenger Details
//               </h3>
//               <p className="text-sm text-gray-600">
//                 Passenger {currentPassengerIndex} of {numPassengers}
//               </p>

//               <PassengerNameForm
//                 fullName={passengerData.fullName}
//                 onChange={(value) =>
//                   setPassengerData({ ...passengerData, fullName: value })
//                 }
//               />

//               <PassengerDocuments
//                 documents={documents}
//                 passengerName={passengerData.fullName}
//                 onExtract={handleExtract}
//                 loading={extracting}
//                 dataExtracted={dataExtracted}
//                 extractedCount={extractedCount}
//               />

//               <div className="border-t pt-8 flex items-center justify-between">
//                 <button
//                   type="button"
//                   onClick={() => setCurrentStep("count")}
//                   className="px-6 py-3 rounded-xl border border-gray-300 text-gray-700 font-medium hover:bg-gray-50"
//                 >
//                   ← Back
//                 </button>
//               </div>
//             </div>
//           )}

//           {/* ================================================================
//               STEP 4: FORM (EDIT MODE)
//           ================================================================ */}
//           {currentStep === "form" && (
//             <FormRenderer
//               config={formConfig}
//               initialValues={{ ...extractedFormData, ...formValues }}
//               onSubmit={handleMoveToReview}
//               onSectionSave={handleSaveFormData}
//               nationality={nationality}
//               portOfEntry={portOfEntry}
//               portOfExit={portOfExit}
//               previousNationalities={previousNationalities}
//               otherNationalities={otherNationalities}
//               country={country}
//               mode="edit"
//             />
//           )}

//           {/* ================================================================
//               STEP 5: REVIEW
//           ================================================================ */}
//           {currentStep === "review" && (
//             <div className="space-y-6">
//               <div className="flex justify-between items-center mb-6">
//                 <h3 className="text-lg font-semibold text-gray-900">
//                   Review Your Application
//                 </h3>

//                 {!hasEditedOnce && (
//                   <button
//                     type="button"
//                     onClick={handleEnableEdit}
//                     className="px-4 py-2 rounded-lg border border-blue-600 text-blue-600 font-medium hover:bg-blue-50"
//                   >
//                     ✏️ Edit Application
//                   </button>
//                 )}
//               </div>

//               <FormRenderer
//                 config={formConfig}
//                 initialValues={formValues}
//                 onSubmit={() => {}}
//                 nationality={nationality}
//                 portOfEntry={portOfEntry}
//                 portOfExit={portOfExit}
//                 previousNationalities={previousNationalities}
//                 otherNationalities={otherNationalities}
//                 country={country}
//                 mode="review"
//                 allowNavigation={true}
//               />

//               <div className="flex justify-end pt-6 border-t">
//                 <button
//                   type="button"
//                   onClick={handleFinalSubmit}
//                   disabled={isSaving}
//                   className="px-8 py-3 rounded-xl bg-green-600 text-white font-semibold hover:bg-green-700 shadow-lg disabled:bg-gray-300"
//                 >
//                   {isSaving ? "Processing..." : "Proceed to Submit"}
//                 </button>
//               </div>
//             </div>
//           )}

//           {/* ================================================================
//               STEP 6: FINAL SUBMISSION SUMMARY
//           ================================================================ */}
//           {currentStep === "submit" && (
//             <div className="space-y-6">
//               <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
//                 <div className="flex items-center gap-2">
//                   <CheckCircle2 className="w-5 h-5 text-green-600" />
//                   <p className="text-sm text-green-800 font-medium">
//                     Application Received, Pending for Review
//                   </p>
//                 </div>
//               </div>

//               <h2 className="text-2xl font-bold text-gray-900 mb-6">
//                 Review & Submit {numPassengers > 1 ? "All Applications" : "Application"}
//               </h2>

//               {/* Application Summary Card */}
//               <div className="bg-white border border-gray-200 rounded-lg p-6 space-y-3">
//                 <h3 className="text-lg font-semibold text-gray-900 mb-4">
//                   Passenger {currentPassengerIndex}: {passengerData.fullName || "N/A"}
//                 </h3>

//                 <div className="space-y-2 text-sm">
//                   <p className="text-gray-700">
//                     <span className="font-medium">Application ID:</span>{" "}
//                     <span className="text-gray-900 font-mono">{applicationId}</span>
//                   </p>

//                   <p className="text-gray-700">
//                     <span className="font-medium">Passport:</span>{" "}
//                     <span className="text-gray-900">
//                       {formValues.passport_number || "Not provided"}
//                     </span>
//                   </p>

//                   <p className="text-gray-700">
//                     <span className="font-medium">Documents:</span>{" "}
//                     <span className="text-gray-900">
//                       {dataExtracted ? `${extractedCount} fields extracted` : "No documents uploaded"}
//                     </span>
//                   </p>
//                 </div>
//               </div>

//               {/* Consent Checkbox */}
//               <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
//                 <label className="flex items-start gap-3 cursor-pointer">
//                   <input
//                     type="checkbox"
//                     checked={consentGiven}
//                     onChange={(e) => setConsentGiven(e.target.checked)}
//                     className="w-5 h-5 mt-0.5 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
//                   />
//                   <span className="text-sm text-gray-800">
//                     I hereby declare that all information provided for all passengers is true and correct to the best of my knowledge.
//                   </span>
//                 </label>
//               </div>

//               {/* Action Buttons */}
//               <div className="flex items-center justify-between pt-6 border-t">
//                 <button
//                   type="button"
//                   onClick={() => setCurrentStep("review")}
//                   className="px-6 py-3 rounded-xl border border-gray-300 text-gray-700 font-medium hover:bg-gray-50"
//                 >
//                   Back
//                 </button>

//                 <button
//                   type="button"
//                   onClick={handleFinalApplicationSubmit}
//                   disabled={!consentGiven || isSaving}
//                   className={`px-8 py-3 rounded-xl font-semibold transition-all ${
//                     consentGiven && !isSaving
//                       ? "bg-green-600 text-white hover:bg-green-700 shadow-lg"
//                       : "bg-gray-300 text-gray-500 cursor-not-allowed"
//                   }`}
//                 >
//                   {isSaving ? "Submitting..." : `Submit ${numPassengers > 1 ? `All ${numPassengers} Applications` : "Application"}`}
//                 </button>
//               </div>
//             </div>
//           )}

//           {/* AI Loader */}
//           {showLoader && (
//             <AIMagicLoader
//               isDone={loaderDone}
//               extractedCount={extractedCount}
//               onClose={() => setShowLoader(false)}
//             />
//           )}
//         </div>
//       </div>
//     </UserLayout>
//   );
// }





// --------------this is working------------

// function CreateNewApplication() {
//   const navigate = useNavigate();

//   const [showLoader, setShowLoader] = useState(false);
//   const [loaderDone, setLoaderDone] = useState(false);
//   const [currentStep, setCurrentStep] = useState("selection");

//   // Visa Master Data
//   const [visaCategories, setVisaCategories] = useState([]);
//   const [nationality, setNationality] = useState([]);
//   const [portOfEntry, setPortOfEntry] = useState([]);
//   const [portOfExit, setPortOfExit] = useState([]);
//   const [previousNationalities, setPreviousNationalities] = useState([]);
//   const [otherNationalities, setOtherNationalities] = useState([]);
//   const [country, setCountries] = useState([]);

//   // User Selections
//   const [selectedCategory, setSelectedCategory] = useState("");
//   const [selectedVisaType, setSelectedVisaType] = useState(null);
//   const [selectedPurpose, setSelectedPurpose] = useState(null);

//   // Documents
//   const [documents, setDocuments] = useState([]);

//   // Passenger Management
//   const [numPassengers, setNumPassengers] = useState(1);
//   const [currentPassengerIndex, setCurrentPassengerIndex] = useState(1);
//   const [passengerData, setPassengerData] = useState({ fullName: "" });

//   // Data Extraction
//   const [extracting, setExtracting] = useState(false);
//   const [applicationId, setApplicationId] = useState(null);
//   const [dataExtracted, setDataExtracted] = useState(false);
//   const [extractedCount, setExtractedCount] = useState(0);
//   const [extractedFormData, setExtractedFormData] = useState({});

//   // Form Values
//   const [formValues, setFormValues] = useState({});

//   // Edit & Submission State
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [hasEditedOnce, setHasEditedOnce] = useState(false);
//   const [isSaving, setIsSaving] = useState(false);
//   const [isSubmitted, setIsSubmitted] = useState(false);

//   // ✅ NEW: Track if we're in edit flow (coming from review)
//   const [isReturningFromEdit, setIsReturningFromEdit] = useState(false);

//   // ✅ NEW STATE: Track uploaded documents with metadata
//   const [uploadedDocuments, setUploadedDocuments] = useState([]);

//   //Consent checkbox state
//   const [consentGiven, setConsentGiven] = useState(false);

//   // ✅ ADD THIS - Form Config State
//   const [formConfig, setFormConfig] = useState(null);
//   const [isLoadingConfig, setIsLoadingConfig] = useState(false);

//   // STEPPER CONFIGURATION
//   const STEPS = [
//     { key: "selection", label: "Visa Type" },
//     { key: "count", label: "Number of Passengers" },
//     { key: "details", label: "Passenger Details" },
//     { key: "form", label: "Form" },
//     { key: "review", label: "Review Your Application" },
//     { key: "submit", label: "Submit" },
//   ];

//   useEffect(() => {
//     fetchVisaCategories();
//     fetchAll();
//   }, []);

//   // ✅ ADD THIS - Load form config when category/purpose changes
//   useEffect(() => {
//     const loadConfig = async () => {
//       if (!selectedCategory || !selectedPurpose?.purpose_code) {
//         setFormConfig(null);
//         setIsLoadingConfig(false);
//         return;
//       }

//       setIsLoadingConfig(true);
//       try {
//         const config = await resolveFormConfig(
//           selectedCategory,
//           selectedPurpose?.purpose_code,
//           applicationId
//         );
//         setFormConfig(config);
//       } catch (error) {
//         console.error("Failed to load form config:", error);
//         setFormConfig(null);
//       } finally {
//         setIsLoadingConfig(false);
//       }
//     };

//     loadConfig();
//   }, [selectedCategory, selectedPurpose?.purpose_code, applicationId]);

//   const fetchVisaCategories = async () => {
//     try {
//       const response = await api.getVisaTypes();
//       setVisaCategories(response.data);
//     } catch (error) {
//       console.error("Error fetching visa categories:", error);
//     }
//   };

//   const fetchAll = async () => {
//     try {
//       const response = await api.getAlldropdowns();
//       setNationality(response.data.nationalities);
//       setPortOfEntry(response.data.port_of_entry);
//       setPortOfExit(response.data.port_of_exit);
//       setPreviousNationalities(response.data.previous_nationalities);
//       setOtherNationalities(response.data.other_nationalities);
//       setCountries(response.data.country_of_birth);
//     } catch (error) {
//       console.error("Error fetching dropdowns:", error);
//     }
//   };

//   useEffect(() => {
//     if (!selectedVisaType?.id) {
//       setDocuments([]);
//       return;
//     }

//     const fetchDocuments = async () => {
//       try {
//         const response = await api.getVisaTypeDocuments(selectedVisaType.id);
//         setDocuments(response.data || []);
//       } catch (error) {
//         console.error("Failed to fetch documents:", error);
//         setDocuments([]);
//       }
//     };

//     fetchDocuments();
//   }, [selectedVisaType]);

//   const categories = useMemo(() => {
//     return visaCategories.map((item) => item.category);
//   }, [visaCategories]);

//   const selectedCategoryData = useMemo(() => {
//     return visaCategories.find((item) => item.category === selectedCategory);
//   }, [visaCategories, selectedCategory]);

//   const visaTypes = useMemo(() => {
//     return selectedCategoryData?.visa_types || [];
//   }, [selectedCategoryData]);

//   const purposes = useMemo(() => {
//     return selectedCategoryData?.purposes || [];
//   }, [selectedCategoryData]);

//   const canProceed = Boolean(
//     selectedCategory && selectedVisaType && selectedPurpose
//   );

//   // const formConfig = resolveFormConfig(
//   //   selectedCategory,
//   //   selectedPurpose?.purpose_code
//   // );



//   // const buildBulkUploadFormData = (applicationId, uploadedFiles) => {
//   //   const formData = new FormData();
//   //   formData.append("application_id", applicationId);

//   //   Object.entries(uploadedFiles).forEach(([documentTypeId, file]) => {
//   //     formData.append("document_type_ids", documentTypeId);
//   //     formData.append("files", file);
//   //   });

//   //   return formData;
//   // };


//   // const handleExtract = async (uploadedFiles) => {
//   //   try {
//   //     setExtracting(true);
//   //     setShowLoader(true);
//   //     setLoaderDone(false);

//   //     // STEP 1: Create application
//   //     const payload = {
//   //       visa_type_id: selectedVisaType.id,
//   //       purpose_code: selectedPurpose.purpose_code,
//   //       num_passengers: 1,
//   //     };

//   //     const appRes = await api.createApplication(payload);
//   //     const appId = appRes.data?.id || appRes.data?.application_id;

//   //     if (!appId) {
//   //       throw new Error("Application ID not received");
//   //     }

//   //     setApplicationId(appId);

//   //     // STEP 2: Upload documents
//   //     const formData = buildBulkUploadFormData(appId, uploadedFiles);
//   //     await api.uploadApplicationDocuments(formData);

//   //     // STEP 3: Extract data from documents using AI
//   //     const extractRes = await api.extractAndMapDocuments(appId);
//   //     const rawExtractedData = extractRes.data?.mapped || {};

//   //     console.log('Raw extracted data from backend:', rawExtractedData);

//   //     // ✅ STEP 4: Normalize/map extracted data to match form field requirements
//   //     const normalizedData = mapExtractedData(rawExtractedData, formConfig);

//   //     console.log('Normalized data for form:', normalizedData);

//   //     setExtractedFormData(normalizedData);

//   //     // Count how many fields were successfully extracted
//   //     setExtractedCount(
//   //       Object.values(normalizedData).filter(Boolean).length
//   //     );

//   //     setDataExtracted(true);
//   //     setLoaderDone(true);
//   //     setCurrentStep("form");
//   //   } catch (error) {
//   //     console.error("Document extraction error:", error);
//   //     alert("Failed to process documents. Please retry.");
//   //   } finally {
//   //     setExtracting(false);
//   //   }
//   // };

//   // Modify handleExtract to accept uploadedDocsArray

//   const buildBulkUploadFormData = (applicationId, uploadedFiles) => {
//     const formData = new FormData();
//     formData.append("application_id", applicationId);

//     // ✅ FIX: uploadedFiles is an object where values contain {file, id, name, documentType}
//     Object.entries(uploadedFiles).forEach(([documentTypeId, fileData]) => {
//       // Extract the actual File object from the fileData
//       const file = fileData.file || fileData; // Handle both formats

//       if (file instanceof File) {
//         formData.append("document_type_ids", documentTypeId);
//         formData.append("files", file); // Append the actual File object
//       } else {
//         console.error(`Invalid file for document type ${documentTypeId}:`, file);
//       }
//     });

//     return formData;
//   };

//   const handleExtract = async (uploadedFiles, uploadedDocsArray) => {
//     try {
//       setExtracting(true);
//       setShowLoader(true);
//       setLoaderDone(false);

//       // Store the uploaded documents immediately (for UI display)
//       setUploadedDocuments(uploadedDocsArray);

//       // STEP 1: Create application
//       const payload = {
//         visa_type_id: selectedVisaType.id,
//         purpose_code: selectedPurpose.purpose_code,
//         num_passengers: 1,
//       };

//       const appRes = await api.createApplication(payload);
//       const appId = appRes.data?.id || appRes.data?.application_id;

//       if (!appId) {
//         throw new Error("Application ID not received");
//       }

//       setApplicationId(appId);

//       // STEP 2: Upload documents
//       // ✅ Pass the uploadedFiles object (not array) which contains File objects
//       const formData = buildBulkUploadFormData(appId, uploadedFiles);

//       // Debug: Log FormData contents
//       console.log("FormData contents:");
//       for (let pair of formData.entries()) {
//         console.log(pair[0], pair[1]);
//       }

//       await api.uploadApplicationDocuments(formData);

//       // STEP 3: Extract data from documents using AI
//       const extractRes = await api.extractAndMapDocuments(appId);
//       const rawExtractedData = extractRes.data?.mapped || {};

//       console.log('Raw extracted data from backend:', rawExtractedData);

//       // ✅ STEP 4: Normalize/map extracted data to match form field requirements
//       const normalizedData = formConfig
//         ? mapExtractedData(rawExtractedData, formConfig)
//         : rawExtractedData;

//       console.log('Normalized data for form:', normalizedData);

//       setExtractedFormData(normalizedData);

//       // Count how many fields were successfully extracted
//       setExtractedCount(
//         Object.values(normalizedData).filter(Boolean).length
//       );

//       setDataExtracted(true);
//       setLoaderDone(true);
//       setCurrentStep("form");
//     } catch (error) {
//       console.error("Document extraction error:", error);
//       alert("Failed to process documents. Please retry.");
//     } finally {
//       setExtracting(false);
//     }
//   };

//   const handleSaveFormData = async (values) => {
//     if (!applicationId) return;

//     try {
//       setIsSaving(true);

//       const payload = buildSubmitPayload(values);
//       await api.updateApplication(applicationId, payload);

//       setFormValues(values);
//     } catch (error) {
//       console.error("Failed to save form data:", error);
//       alert("Failed to save data. Please try again.");
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   // ✅ FIXED: Handle moving from form to review (ALWAYS goes to review, never directly to submit)
//   const handleMoveToReview = async (values) => {
//     await handleSaveFormData(values);
//     setIsEditMode(false); // Exit edit mode
//     setIsReturningFromEdit(false); // Clear the edit flag
//     setCurrentStep("review"); // Always go to review step
//   };

//   // ✅ FIXED: Enable edit mode and set flag
//   const handleEnableEdit = () => {
//     if (hasEditedOnce) {
//       alert("You have already used your one-time edit.");
//       return;
//     }

//     setIsEditMode(true);
//     setHasEditedOnce(true);
//     setIsReturningFromEdit(true);
//     setCurrentStep("form");
//   };



//   const handleFinalApplicationSubmit = async () => {
//     if (!consentGiven) {
//       alert("Please accept the declaration to proceed.");
//       return;
//     }

//     try {
//       setIsSaving(true);

//       const payload = {
//         ...buildSubmitPayload(formValues),
//         status: "Application Received, Pending for Review",
//         consent_given: true,
//       };

//       await api.updateApplication(applicationId, payload);

//       alert("Application submitted successfully!");
//       navigate('/dashboard');
//     } catch (error) {
//       console.error("Final submission error:", error);
//       alert("Failed to submit application.");
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   return (
//     <UserLayout>
//       <div className="min-h-screen bg-slate-50 p-4">
//         <div className="max-w-7xl mx-auto bg-white border rounded-xl p-6">

//           <Stepper steps={STEPS} currentStep={currentStep} />

//           {isSaving && (
//             <div className="mb-4 text-sm text-blue-600 flex items-center gap-2">
//               <div className="animate-spin h-4 w-4 border-2 border-blue-600 border-t-transparent rounded-full"></div>
//               Saving...
//             </div>
//           )}

//           {/* STEP 1: VISA SELECTION */}
//           {/* {currentStep === "selection" && (
//             <>
//               <VisaCategory
//                 categories={categories}
//                 selectedCategory={selectedCategory}
//                 onSelectCategory={(cat) => {
//                   setSelectedCategory(cat);
//                   setSelectedVisaType(null);
//                   setSelectedPurpose(null);
//                 }}
//               />

//               {selectedCategory && (
//                 <div className="mt-10">
//                   <VisaType
//                     visaTypes={visaTypes}
//                     selectedVisaType={selectedVisaType}
//                     onSelectVisaType={(type) => {
//                       setSelectedVisaType(type);
//                       setSelectedPurpose(null);
//                     }}
//                   />
//                 </div>
//               )}

//               {selectedVisaType && (
//                 <div className="mt-10">
//                   <VisaPurpose
//                     purposes={purposes}
//                     selectedPurpose={selectedPurpose}
//                     onSelectPurpose={setSelectedPurpose}
//                   />
//                 </div>
//               )}

//               {canProceed && (
//                 <div className="mt-8 flex justify-end">
//                   <button
//                     type="button"
//                     onClick={() => setCurrentStep("count")}
//                     className="px-6 py-3 rounded-xl bg-blue-600 text-white font-semibold hover:bg-blue-700"
//                   >
//                     Next
//                   </button>
//                 </div>
//               )}
//             </>
//           )} */}

//           {/* STEP 1: VISA SELECTION */}
//           {currentStep === "selection" && (
//             <>
//               {/* Category Selection Screen */}
//               {!selectedCategory && (
//                 <VisaCategory
//                   categories={categories}
//                   selectedCategory={selectedCategory}
//                   onSelectCategory={(cat) => {
//                     setSelectedCategory(cat);
//                     setSelectedVisaType(null);
//                     setSelectedPurpose(null);
//                   }}
//                 />
//               )}

//               {/* Visa Type Selection Screen */}
//               {selectedCategory && !selectedVisaType && (
//                 <div className="space-y-6">
//                   <button
//                     type="button"
//                     onClick={() => {
//                       setSelectedCategory(null);
//                       setSelectedVisaType(null);
//                       setSelectedPurpose(null);
//                     }}
//                     className="flex items-center gap-2 text-gray-600 hover:text-gray-900"
//                   >
//                     <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
//                     </svg>
//                     Back
//                   </button>

//                   <VisaType
//                     visaTypes={visaTypes}
//                     selectedVisaType={selectedVisaType}
//                     onSelectVisaType={(type) => {
//                       setSelectedVisaType(type);
//                       setSelectedPurpose(null);
//                     }}
//                   />
//                 </div>
//               )}

//               {/* Visa Purpose Selection Screen */}
//               {selectedVisaType && (
//                 <div className="space-y-6">
//                   <button
//                     type="button"
//                     onClick={() => {
//                       setSelectedVisaType(null);
//                       setSelectedPurpose(null);
//                     }}
//                     className="flex items-center gap-2 text-gray-600 hover:text-gray-900"
//                   >
//                     <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
//                     </svg>
//                     Back
//                   </button>

//                   <VisaPurpose
//                     purposes={purposes}
//                     selectedPurpose={selectedPurpose}
//                     onSelectPurpose={setSelectedPurpose}
//                   />

//                   {/* Next Button - Shows on the same screen after purpose is selected */}
//                   {canProceed && selectedPurpose && (
//                     <div className="mt-8 flex justify-end">
//                       <button
//                         type="button"
//                         onClick={() => setCurrentStep("count")}
//                         className="px-6 py-3 rounded-xl bg-blue-600 text-white font-semibold hover:bg-blue-700"
//                       >
//                         Next
//                       </button>
//                     </div>
//                   )}
//                 </div>
//               )}
//             </>
//           )}

//           {/* STEP 2: NUMBER OF PASSENGERS */}
//           {currentStep === "count" && (
//             <div className="space-y-4">
//               <h3 className="text-lg font-semibold text-gray-900">
//                 Number of Passengers
//               </h3>

//               <div className="max-w-md space-y-4">
//                 <label className="block text-sm font-medium text-gray-700">
//                   How many passengers? <span className="text-gray-400">(1–50)</span>
//                 </label>

//                 <input
//                   type="number"
//                   min={1}
//                   max={50}
//                   value={numPassengers}
//                   onChange={(e) => {
//                     const value = Math.max(1, Math.min(50, Number(e.target.value)));
//                     setNumPassengers(value);
//                     setCurrentPassengerIndex((prev) => Math.min(prev, value));
//                   }}
//                   className="w-40 px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 text-gray-900"
//                 />

//                 <p className="text-sm text-gray-600">
//                   Each passenger will have a separate application.
//                 </p>
//               </div>

//               <div className="flex items-center justify-between pt-6">
//                 <button
//                   type="button"
//                   onClick={() => setCurrentStep("selection")}
//                   className="px-6 py-3 rounded-xl border border-gray-300 text-gray-700 font-medium hover:bg-gray-50"
//                 >
//                   ← Back
//                 </button>

//                 <button
//                   type="button"
//                   onClick={() => {
//                     setCurrentPassengerIndex(1);
//                     setCurrentStep("details");
//                   }}
//                   className="px-8 py-3 rounded-xl bg-blue-600 text-white font-semibold hover:bg-blue-700"
//                 >
//                   Next →
//                 </button>
//               </div>
//             </div>
//           )}

//           {/* STEP 3: PASSENGER DETAILS */}
//           {currentStep === "details" && (
//             <div className="space-y-5">
//               <h3 className="text-lg font-bold text-gray-900 mb-2">
//                 Passenger Details
//               </h3>
//               <p className="text-sm text-gray-600">
//                 Passenger {currentPassengerIndex} of {numPassengers}
//               </p>

//               <PassengerNameForm
//                 fullName={passengerData.fullName}
//                 onChange={(value) =>
//                   setPassengerData({ ...passengerData, fullName: value })
//                 }
//               />

//               <PassengerDocuments
//                 documents={documents}
//                 passengerName={passengerData.fullName}
//                 onExtract={handleExtract}
//                 loading={extracting}
//                 dataExtracted={dataExtracted}
//                 extractedCount={extractedCount}
//               />

//               <div className="border-t pt-8 flex items-center justify-between">
//                 <button
//                   type="button"
//                   onClick={() => setCurrentStep("count")}
//                   className="px-6 py-3 rounded-xl border border-gray-300 text-gray-700 font-medium hover:bg-gray-50"
//                 >
//                   ← Back
//                 </button>
//               </div>
//             </div>
//           )}

//           {/* STEP 4: FORM (EDIT MODE) */}
//           {/* {currentStep === "form" && (
//             <>
             
             

//               <FormRenderer
//               config={formConfig}
//               initialValues={{ ...extractedFormData, ...formValues }}
//               onSubmit={handleMoveToReview}
//               onSectionSave={handleSaveFormData}
//               nationality={nationality}
//               portOfEntry={portOfEntry}
//               portOfExit={portOfExit}
//               previousNationalities={previousNationalities}
//               otherNationalities={otherNationalities}
//               country={country}
//               mode="edit"
//               uploadedDocuments={uploadedDocuments} // ✅ NEW PROP
//               applicationId={applicationId} // ✅ NEW PROP
//             />
//             </>
//           )} */}

//           {/* STEP 4: FORM (EDIT MODE) */}
//           {currentStep === "form" && (
//             <>
//               {isLoadingConfig ? (
//                 <div className="flex items-center justify-center py-12">
//                   <div className="text-gray-600">Loading form configuration...</div>
//                 </div>
//               ) : !formConfig ? (
//                 <div className="flex items-center justify-center py-12">
//                   <div className="text-red-600">Unable to load form configuration</div>
//                 </div>
//               ) : (
//                 <FormRenderer
//                   config={formConfig}
//                   initialValues={{ ...extractedFormData, ...formValues }}
//                   onSubmit={handleMoveToReview}
//                   onSectionSave={handleSaveFormData}
//                   nationality={nationality}
//                   portOfEntry={portOfEntry}
//                   portOfExit={portOfExit}
//                   previousNationalities={previousNationalities}
//                   otherNationalities={otherNationalities}
//                   country={country}
//                   mode="edit"
//                   uploadedDocuments={uploadedDocuments}
//                   applicationId={applicationId}
//                 />
//               )}
//             </>
//           )}

//           {/* STEP 5: REVIEW */}
//           {/* {currentStep === "review" && (
//             <div className="space-y-6">
//               <div className="flex justify-between items-center mb-6">
//                 <h3 className="text-lg font-semibold text-gray-900">
//                   Review Your Application
//                 </h3>
                
//                 {!hasEditedOnce && (
//                   <button
//                     type="button"
//                     onClick={handleEnableEdit}
//                     className="px-4 py-2 rounded-lg border border-blue-600 text-blue-600 font-medium hover:bg-blue-50"
//                   >
//                     ✏️ Edit Application
//                   </button>
//                 )}
//               </div>

             

//               <FormRenderer
//                 config={formConfig}
//                 initialValues={formValues}
//                 onSubmit={() => {}}
//                 nationality={nationality}
//                 portOfEntry={portOfEntry}
//                 portOfExit={portOfExit}
//                 previousNationalities={previousNationalities}
//                 otherNationalities={otherNationalities}
//                 country={country}
//                 mode="review"
//                 allowNavigation={true}
//                 uploadedDocuments={uploadedDocuments} // ✅ NEW PROP
//                 applicationId={applicationId} // ✅ NEW PROP
//               />

             
//               <div className="flex justify-end pt-6 border-t">
//                 <button
//                   type="button"
//                   onClick={() => setCurrentStep("submit")} // ✅ Go to step 6, not final submit
//                   disabled={isSaving}
//                   className="px-8 py-3 rounded-xl bg-green-600 text-white font-semibold hover:bg-green-700 shadow-lg disabled:bg-gray-300"
//                 >
//                   Proceed to Submit
//                 </button>
//               </div>
//             </div>
//           )} */}

//           {/* STEP 5: REVIEW */}
//           {currentStep === "review" && (
//             <div className="space-y-6">
//               <div className="flex justify-between items-center mb-6">
//                 <h3 className="text-lg font-semibold text-gray-900">
//                   Review Your Application
//                 </h3>

//                 {!hasEditedOnce && (
//                   <button
//                     type="button"
//                     onClick={handleEnableEdit}
//                     className="px-4 py-2 rounded-lg border border-blue-600 text-blue-600 font-medium hover:bg-blue-50"
//                   >
//                     ✏️ Edit Application
//                   </button>
//                 )}
//               </div>

//               {isLoadingConfig ? (
//                 <div className="flex items-center justify-center py-12">
//                   <div className="text-gray-600">Loading form configuration...</div>
//                 </div>
//               ) : !formConfig ? (
//                 <div className="flex items-center justify-center py-12">
//                   <div className="text-red-600">Unable to load form configuration</div>
//                 </div>
//               ) : (
//                 <FormRenderer
//                   config={formConfig}
//                   initialValues={formValues}
//                   onSubmit={() => { }}
//                   nationality={nationality}
//                   portOfEntry={portOfEntry}
//                   portOfExit={portOfExit}
//                   previousNationalities={previousNationalities}
//                   otherNationalities={otherNationalities}
//                   country={country}
//                   mode="review"
//                   allowNavigation={true}
//                   uploadedDocuments={uploadedDocuments}
//                   applicationId={applicationId}
//                 />
//               )}

//               <div className="flex justify-end pt-6 border-t">
//                 <button
//                   type="button"
//                   onClick={() => setCurrentStep("submit")}
//                   disabled={isSaving || !formConfig}
//                   className="px-8 py-3 rounded-xl bg-green-600 text-white font-semibold hover:bg-green-700 shadow-lg disabled:bg-gray-300"
//                 >
//                   Proceed to Submit
//                 </button>
//               </div>
//             </div>
//           )}

//           {/* STEP 6: FINAL SUBMISSION SUMMARY */}
//           {currentStep === "submit" && (
//             <div className="space-y-6">
//               <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
//                 <div className="flex items-center gap-2">
//                   <CheckCircle2 className="w-5 h-5 text-green-600" />
//                   <p className="text-sm text-green-800 font-medium">
//                     Application Received, Pending for Review
//                   </p>
//                 </div>
//               </div>

//               <h2 className="text-2xl font-bold text-gray-900 mb-6">
//                 Review & Submit {numPassengers > 1 ? "All Applications" : "Application"}
//               </h2>

//               <div className="bg-white border border-gray-200 rounded-lg p-6 space-y-3">
//                 <h3 className="text-lg font-semibold text-gray-900 mb-4">
//                   Passenger {currentPassengerIndex}: {passengerData.fullName || "N/A"}
//                 </h3>

//                 <div className="space-y-2 text-sm">
//                   <p className="text-gray-700">
//                     <span className="font-medium">Application ID:</span>{" "}
//                     <span className="text-gray-900 font-mono">{applicationId}</span>
//                   </p>

//                   <p className="text-gray-700">
//                     <span className="font-medium">Passport:</span>{" "}
//                     <span className="text-gray-900">
//                       {formValues.passport_number || "Not provided"}
//                     </span>
//                   </p>

//                   <p className="text-gray-700">
//                     <span className="font-medium">Documents:</span>{" "}
//                     <span className="text-gray-900">
//                       {dataExtracted ? `${extractedCount} fields extracted` : "No documents uploaded"}
//                     </span>
//                   </p>
//                 </div>
//               </div>

//               <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
//                 <label className="flex items-start gap-3 cursor-pointer">
//                   <input
//                     type="checkbox"
//                     checked={consentGiven}
//                     onChange={(e) => setConsentGiven(e.target.checked)}
//                     className="w-5 h-5 mt-0.5 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
//                   />
//                   <span className="text-sm text-gray-800">
//                     I hereby declare that all information provided for all passengers is true and correct to the best of my knowledge.
//                   </span>
//                 </label>
//               </div>

//               <div className="flex items-center justify-between pt-6 border-t">
//                 <button
//                   type="button"
//                   onClick={() => setCurrentStep("review")}
//                   className="px-6 py-3 rounded-xl border border-gray-300 text-gray-700 font-medium hover:bg-gray-50"
//                 >
//                   Back
//                 </button>

//                 <button
//                   type="button"
//                   onClick={handleFinalApplicationSubmit}
//                   disabled={!consentGiven || isSaving}
//                   className={`px-8 py-3 rounded-xl font-semibold transition-all ${consentGiven && !isSaving
//                     ? "bg-green-600 text-white hover:bg-green-700 shadow-lg"
//                     : "bg-gray-300 text-gray-500 cursor-not-allowed"
//                     }`}
//                 >
//                   {isSaving ? "Submitting..." : `Submit ${numPassengers > 1 ? `All ${numPassengers} Applications` : "Application"}`}
//                 </button>
//               </div>
//             </div>
//           )}

//           {showLoader && (
//             <AIMagicLoader
//               isDone={loaderDone}
//               extractedCount={extractedCount}
//               onClose={() => setShowLoader(false)}
//             />
//           )}
//         </div>
//       </div>
//     </UserLayout>
//   );
// }



// =-----------------------------

function CreateNewApplication() {
  const navigate = useNavigate();

  const [showLoader, setShowLoader] = useState(false);
  const [loaderDone, setLoaderDone] = useState(false);
  const [currentStep, setCurrentStep] = useState("selection");

  // Visa Master Data
  const [visaCategories, setVisaCategories] = useState([]);
  const [nationality, setNationality] = useState([]);
  const [portOfEntry, setPortOfEntry] = useState([]);
  const [portOfExit, setPortOfExit] = useState([]);
  const [previousNationalities, setPreviousNationalities] = useState([]);
  const [otherNationalities, setOtherNationalities] = useState([]);
  const [country, setCountries] = useState([]);

  // User Selections
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedVisaType, setSelectedVisaType] = useState(null);
  const [selectedPurpose, setSelectedPurpose] = useState(null);

  // Documents
  const [documents, setDocuments] = useState([]);

  // Passenger Management
  const [numPassengers, setNumPassengers] = useState(1);
  const [currentPassengerIndex, setCurrentPassengerIndex] = useState(1);
  const [passengerData, setPassengerData] = useState({ fullName: "" });

  // Data Extraction
  const [extracting, setExtracting] = useState(false);
  const [applicationId, setApplicationId] = useState(null);
  const [dataExtracted, setDataExtracted] = useState(false);
  const [extractedCount, setExtractedCount] = useState(0);
  const [extractedFormData, setExtractedFormData] = useState({});

  // Form Values
  const [formValues, setFormValues] = useState({});

  // Edit & Submission State
  const [isEditMode, setIsEditMode] = useState(false);
  const [hasEditedOnce, setHasEditedOnce] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);

  // ✅ NEW: Track if we're in edit flow (coming from review)
  const [isReturningFromEdit, setIsReturningFromEdit] = useState(false);

  // ✅ NEW STATE: Track uploaded documents with metadata
  const [uploadedDocuments, setUploadedDocuments] = useState([]);

  //Consent checkbox state
  const [consentGiven, setConsentGiven] = useState(false);

  // ✅ ADD THIS - Form Config State
  const [formConfig, setFormConfig] = useState(null);
  const [isLoadingConfig, setIsLoadingConfig] = useState(false);

  // ✅ ADD THIS: Track passengers array
const [passengersData, setPassengersData] = useState([]);

  // STEPPER CONFIGURATION
  const STEPS = [
    { key: "selection", label: "Visa Type" },
    { key: "count", label: "Number of Passengers" },
    { key: "details", label: "Passenger Details" },
    { key: "form", label: "Form" },
    { key: "review", label: "Review Your Application" },
    { key: "submit", label: "Submit" },
  ];

  useEffect(() => {
    fetchVisaCategories();
    fetchAll();
  }, []);

  // ✅ ADD THIS - Load form config when category/purpose changes
  useEffect(() => {
    const loadConfig = async () => {
      if (!selectedCategory || !selectedPurpose?.purpose_code) {
        setFormConfig(null);
        setIsLoadingConfig(false);
        return;
      }

      setIsLoadingConfig(true);
      try {
        const config = await resolveFormConfig(
          selectedCategory,
          selectedPurpose?.purpose_code,
          applicationId
        );
        setFormConfig(config);
      } catch (error) {
        console.error("Failed to load form config:", error);
        setFormConfig(null);
      } finally {
        setIsLoadingConfig(false);
      }
    };

    loadConfig();
  }, [selectedCategory, selectedPurpose?.purpose_code, applicationId]);

  const fetchVisaCategories = async () => {
    try {
      const response = await api.getVisaTypes();
      setVisaCategories(response.data);
    } catch (error) {
      console.error("Error fetching visa categories:", error);
    }
  };

  const fetchAll = async () => {
    try {
      const response = await api.getAlldropdowns();
      setNationality(response.data.nationalities);
      setPortOfEntry(response.data.port_of_entry);
      setPortOfExit(response.data.port_of_exit);
      setPreviousNationalities(response.data.previous_nationalities);
      setOtherNationalities(response.data.other_nationalities);
      setCountries(response.data.country_of_birth);
    } catch (error) {
      console.error("Error fetching dropdowns:", error);
    }
  };

  useEffect(() => {
    if (!selectedVisaType?.id) {
      setDocuments([]);
      return;
    }

    const fetchDocuments = async () => {
      try {
        const response = await api.getVisaTypeDocuments(selectedVisaType.id);
        setDocuments(response.data || []);
      } catch (error) {
        console.error("Failed to fetch documents:", error);
        setDocuments([]);
      }
    };

    fetchDocuments();
  }, [selectedVisaType]);

  const categories = useMemo(() => {
    return visaCategories.map((item) => item.category);
  }, [visaCategories]);

  const selectedCategoryData = useMemo(() => {
    return visaCategories.find((item) => item.category === selectedCategory);
  }, [visaCategories, selectedCategory]);

  const visaTypes = useMemo(() => {
    return selectedCategoryData?.visa_types || [];
  }, [selectedCategoryData]);

  const purposes = useMemo(() => {
    return selectedCategoryData?.purposes || [];
  }, [selectedCategoryData]);

  const canProceed = Boolean(
    selectedCategory && selectedVisaType && selectedPurpose
  );

  // const formConfig = resolveFormConfig(
  //   selectedCategory,
  //   selectedPurpose?.purpose_code
  // );



  // const buildBulkUploadFormData = (applicationId, uploadedFiles) => {
  //   const formData = new FormData();
  //   formData.append("application_id", applicationId);

  //   Object.entries(uploadedFiles).forEach(([documentTypeId, file]) => {
  //     formData.append("document_type_ids", documentTypeId);
  //     formData.append("files", file);
  //   });

  //   return formData;
  // };


  // const handleExtract = async (uploadedFiles) => {
  //   try {
  //     setExtracting(true);
  //     setShowLoader(true);
  //     setLoaderDone(false);

  //     // STEP 1: Create application
  //     const payload = {
  //       visa_type_id: selectedVisaType.id,
  //       purpose_code: selectedPurpose.purpose_code,
  //       num_passengers: 1,
  //     };

  //     const appRes = await api.createApplication(payload);
  //     const appId = appRes.data?.id || appRes.data?.application_id;

  //     if (!appId) {
  //       throw new Error("Application ID not received");
  //     }

  //     setApplicationId(appId);

  //     // STEP 2: Upload documents
  //     const formData = buildBulkUploadFormData(appId, uploadedFiles);
  //     await api.uploadApplicationDocuments(formData);

  //     // STEP 3: Extract data from documents using AI
  //     const extractRes = await api.extractAndMapDocuments(appId);
  //     const rawExtractedData = extractRes.data?.mapped || {};

  //     console.log('Raw extracted data from backend:', rawExtractedData);

  //     // ✅ STEP 4: Normalize/map extracted data to match form field requirements
  //     const normalizedData = mapExtractedData(rawExtractedData, formConfig);

  //     console.log('Normalized data for form:', normalizedData);

  //     setExtractedFormData(normalizedData);

  //     // Count how many fields were successfully extracted
  //     setExtractedCount(
  //       Object.values(normalizedData).filter(Boolean).length
  //     );

  //     setDataExtracted(true);
  //     setLoaderDone(true);
  //     setCurrentStep("form");
  //   } catch (error) {
  //     console.error("Document extraction error:", error);
  //     alert("Failed to process documents. Please retry.");
  //   } finally {
  //     setExtracting(false);
  //   }
  // };

  // Modify handleExtract to accept uploadedDocsArray

  const buildBulkUploadFormData = (applicationId, uploadedFiles) => {
    const formData = new FormData();
    formData.append("application_id", applicationId);

    // ✅ FIX: uploadedFiles is an object where values contain {file, id, name, documentType}
    Object.entries(uploadedFiles).forEach(([documentTypeId, fileData]) => {
      // Extract the actual File object from the fileData
      const file = fileData.file || fileData; // Handle both formats

      if (file instanceof File) {
        formData.append("document_type_ids", documentTypeId);
        formData.append("files", file); // Append the actual File object
      } else {
        console.error(`Invalid file for document type ${documentTypeId}:`, file);
      }
    });

    return formData;
  };

  const handleExtract = async (uploadedFiles, uploadedDocsArray) => {
    try {
      setExtracting(true);
      setShowLoader(true);
      setLoaderDone(false);

      // Store the uploaded documents immediately (for UI display)
      setUploadedDocuments(uploadedDocsArray);

      // STEP 1: Create application
      const payload = {
        visa_type_id: selectedVisaType.id,
        purpose_code: selectedPurpose.purpose_code,
        num_passengers: 1,
      };

      const appRes = await api.createApplication(payload);
      const appId = appRes.data?.id || appRes.data?.application_id;

      if (!appId) {
        throw new Error("Application ID not received");
      }

      setApplicationId(appId);

      // STEP 2: Upload documents
      // ✅ Pass the uploadedFiles object (not array) which contains File objects
      const formData = buildBulkUploadFormData(appId, uploadedFiles);

      // Debug: Log FormData contents
      console.log("FormData contents:");
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }

      await api.uploadApplicationDocuments(formData);

      // STEP 3: Extract data from documents using AI
      const extractRes = await api.extractAndMapDocuments(appId);
      const rawExtractedData = extractRes.data?.mapped || {};

      console.log('Raw extracted data from backend:', rawExtractedData);

      // ✅ STEP 4: Normalize/map extracted data to match form field requirements
      const normalizedData = formConfig
        ? mapExtractedData(rawExtractedData, formConfig)
        : rawExtractedData;

      console.log('Normalized data for form:', normalizedData);

      setExtractedFormData(normalizedData);

      // Count how many fields were successfully extracted
      setExtractedCount(
        Object.values(normalizedData).filter(Boolean).length
      );

      setDataExtracted(true);
      setLoaderDone(true);
      setCurrentStep("form");
    } catch (error) {
      console.error("Document extraction error:", error);
      alert("Failed to process documents. Please retry.");
    } finally {
      setExtracting(false);
    }
  };

  const handleSaveFormData = async (values) => {
    if (!applicationId) return;

    try {
      setIsSaving(true);

      const payload = buildSubmitPayload(values);
      await api.updateApplication(applicationId, payload);

      setFormValues(values);
    } catch (error) {
      console.error("Failed to save form data:", error);
      alert("Failed to save data. Please try again.");
    } finally {
      setIsSaving(false);
    }
  };

  // ✅ FIXED: Handle moving from form to review (ALWAYS goes to review, never directly to submit)
  const handleMoveToReview = async (values) => {
    await handleSaveFormData(values);
    setIsEditMode(false); // Exit edit mode
    setIsReturningFromEdit(false); // Clear the edit flag
    setCurrentStep("review"); // Always go to review step
  };

  // ✅ FIXED: Enable edit mode and set flag
  const handleEnableEdit = () => {
    if (hasEditedOnce) {
      alert("You have already used your one-time edit.");
      return;
    }

    setIsEditMode(true);
    setHasEditedOnce(true);
    setIsReturningFromEdit(true);
    setCurrentStep("form");
  };



  // const handleFinalApplicationSubmit = async () => {
  //   if (!consentGiven) {
  //     alert("Please accept the declaration to proceed.");
  //     return;
  //   }

  //   try {
  //     setIsSaving(true);

  //     const payload = {
  //       ...buildSubmitPayload(formValues),
  //       status: "Application Received, Pending for Review",
  //       consent_given: true,
  //     };

  //     await api.updateApplication(applicationId, payload);

  //     alert("Application submitted successfully!");
  //     navigate('/dashboard');
  //   } catch (error) {
  //     console.error("Final submission error:", error);
  //     alert("Failed to submit application.");
  //   } finally {
  //     setIsSaving(false);
  //   }
  // };



  
  
// ✅ MODIFY: After final submit, check if there are more passengers


const handleFinalApplicationSubmit = async () => {
  if (!consentGiven) {
    alert("Please accept the declaration to proceed.");
    return;
  }

  try {
    setIsSaving(true);

    const payload = {
      ...buildSubmitPayload(formValues),
      status: "Application Received, Pending for Review",
      consent_given: true,
    };

    await api.updateApplication(applicationId, payload);

    // ✅ Store completed passenger data
    const completedPassenger = {
      index: currentPassengerIndex,
      name: passengerData.fullName,
      applicationId: applicationId,
      formValues: formValues,
    };
    
    setPassengersData([...passengersData, completedPassenger]);

    // ✅ CHECK: Are there more passengers?
    if (currentPassengerIndex < numPassengers) {
      // Move to next passenger
      alert(`Passenger ${currentPassengerIndex} application submitted! Now complete passenger ${currentPassengerIndex + 1}.`);
      
      // Reset for next passenger
      setCurrentPassengerIndex(currentPassengerIndex + 1);
      setPassengerData({ fullName: "" });
      setApplicationId(null);
      setDataExtracted(false);
      setExtractedCount(0);
      setExtractedFormData({});
      setFormValues({});
      setUploadedDocuments([]);
      setConsentGiven(false);
      setHasEditedOnce(false);
      setIsEditMode(false);
      
      // ✅ Go back to details step for next passenger
      setCurrentStep("details");
      
    } else {
      // All passengers completed - navigate to dashboard
      alert(`Application submitted successfully!`);
      navigate('/dashboard');
    }
    
  } catch (error) {
    console.error("Final submission error:", error);
    alert("Failed to submit application.");
  } finally {
    setIsSaving(false);
  }
};

  
  return (
    <UserLayout>
      <div className="min-h-screen bg-slate-50 p-4">
        <div className="max-w-7xl mx-auto bg-white border rounded-xl p-6">

          <Stepper steps={STEPS} currentStep={currentStep} />


          {isSaving && (
            <div className="mb-4 text-sm text-blue-600 flex items-center gap-2">
              <div className="animate-spin h-4 w-4 border-2 border-blue-600 border-t-transparent rounded-full"></div>
              Saving...
            </div>
          )}
  

          {/* STEP 1: VISA SELECTION */}
          {currentStep === "selection" && (
            <>
              {/* Category Selection Screen */}
              {!selectedCategory && (
                <VisaCategory
                  categories={categories}
                  selectedCategory={selectedCategory}
                  onSelectCategory={(cat) => {
                    setSelectedCategory(cat);
                    setSelectedVisaType(null);
                    setSelectedPurpose(null);
                  }}
                />
              )}

              {/* Visa Type Selection Screen */}
              {selectedCategory && !selectedVisaType && (
                <div className="space-y-6">
                  <button
                    type="button"
                    onClick={() => {
                      setSelectedCategory(null);
                      setSelectedVisaType(null);
                      setSelectedPurpose(null);
                    }}
                    className="flex items-center gap-2 text-gray-600 hover:text-gray-900"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                    </svg>
                    Back
                  </button>

                  <VisaType
                    visaTypes={visaTypes}
                    selectedVisaType={selectedVisaType}
                    onSelectVisaType={(type) => {
                      setSelectedVisaType(type);
                      setSelectedPurpose(null);
                    }}
                  />
                </div>
              )}

              {/* Visa Purpose Selection Screen */}
              {selectedVisaType && (
                <div className="space-y-6">
                  <button
                    type="button"
                    onClick={() => {
                      setSelectedVisaType(null);
                      setSelectedPurpose(null);
                    }}
                    className="flex items-center gap-2 text-gray-600 hover:text-gray-900"
                  >
                    <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                    </svg>
                    Back
                  </button>

                  <VisaPurpose
                    purposes={purposes}
                    selectedPurpose={selectedPurpose}
                    onSelectPurpose={setSelectedPurpose}
                  />

                  {/* Next Button - Shows on the same screen after purpose is selected */}
                  {canProceed && selectedPurpose && (
                    <div className="mt-8 flex justify-end">
                      <button
                        type="button"
                        onClick={() => setCurrentStep("count")}
                        className="px-6 py-3 rounded-xl bg-blue-600 text-white font-semibold hover:bg-blue-700"
                      >
                        Next
                      </button>
                    </div>
                  )}
                </div>
              )}
            </>
          )}

          {/* STEP 2: NUMBER OF PASSENGERS */}
          {currentStep === "count" && (
            <div className="space-y-4">
              <h3 className="text-lg font-semibold text-gray-900">
                Number of Passengers
              </h3>

              <div className="max-w-md space-y-4">
                <label className="block text-sm font-medium text-gray-700">
                  How many passengers? <span className="text-gray-400">(1–50)</span>
                </label>

                <input
                  type="number"
                  min={1}
                  max={50}
                  value={numPassengers}
                  onChange={(e) => {
                    const value = Math.max(1, Math.min(50, Number(e.target.value)));
                    setNumPassengers(value);
                    setCurrentPassengerIndex((prev) => Math.min(prev, value));
                  }}
                  className="w-40 px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 text-gray-900"
                />

                <p className="text-sm text-gray-600">
                  Each passenger will have a separate application.
                </p>
              </div>

              <div className="flex items-center justify-between pt-6">
                <button
                  type="button"
                  onClick={() => setCurrentStep("selection")}
                  className="px-6 py-3 rounded-xl border border-gray-300 text-gray-700 font-medium hover:bg-gray-50"
                >
                  ← Back
                </button>

                <button
                  type="button"
                  onClick={() => {
                    setCurrentPassengerIndex(1);
                    setCurrentStep("details");
                  }}
                  className="px-8 py-3 rounded-xl bg-blue-600 text-white font-semibold hover:bg-blue-700"
                >
                  Next →
                </button>
              </div>
            </div>
          )}

          {/* STEP 3: PASSENGER DETAILS */}
          {currentStep === "details" && (
            <div className="space-y-5">
              <h3 className="text-lg font-bold text-gray-900 mb-2">
                Passenger Details
              </h3>
              <p className="text-sm text-gray-600">
                Passenger {currentPassengerIndex} of {numPassengers}
              </p>

              <PassengerNameForm
                fullName={passengerData.fullName}
                onChange={(value) =>
                  setPassengerData({ ...passengerData, fullName: value })
                }
              />

              <PassengerDocuments
                documents={documents}
                passengerName={passengerData.fullName}
                onExtract={handleExtract}
                loading={extracting}
                dataExtracted={dataExtracted}
                extractedCount={extractedCount}
              />

              <div className="border-t pt-8 flex items-center justify-between">
                <button
                  type="button"
                  onClick={() => setCurrentStep("count")}
                  className="px-6 py-3 rounded-xl border border-gray-300 text-gray-700 font-medium hover:bg-gray-50"
                >
                  ← Back
                </button>
              </div>
            </div>
          )}

          {/* STEP 4: FORM (EDIT MODE) */}
          {/* {currentStep === "form" && (
            <>
             
             

              <FormRenderer
              config={formConfig}
              initialValues={{ ...extractedFormData, ...formValues }}
              onSubmit={handleMoveToReview}
              onSectionSave={handleSaveFormData}
              nationality={nationality}
              portOfEntry={portOfEntry}
              portOfExit={portOfExit}
              previousNationalities={previousNationalities}
              otherNationalities={otherNationalities}
              country={country}
              mode="edit"
              uploadedDocuments={uploadedDocuments} // ✅ NEW PROP
              applicationId={applicationId} // ✅ NEW PROP
            />
            </>
          )} */}

          {/* STEP 4: FORM (EDIT MODE) */}
          {currentStep === "form" && (
            <>
              {isLoadingConfig ? (
                <div className="flex items-center justify-center py-12">
                  <div className="text-gray-600">Loading form configuration...</div>
                </div>
              ) : !formConfig ? (
                <div className="flex items-center justify-center py-12">
                  <div className="text-red-600">Unable to load form configuration</div>
                </div>
              ) : (
                <FormRenderer
                  config={formConfig}
                  initialValues={{ ...extractedFormData, ...formValues }}
                  onSubmit={handleMoveToReview}
                  onSectionSave={handleSaveFormData}
                  nationality={nationality}
                  portOfEntry={portOfEntry}
                  portOfExit={portOfExit}
                  previousNationalities={previousNationalities}
                  otherNationalities={otherNationalities}
                  country={country}
                  mode="edit"
                  uploadedDocuments={uploadedDocuments}
                  applicationId={applicationId}
                />
              )}
            </>
          )}

          {/* STEP 5: REVIEW */}
          {/* {currentStep === "review" && (
            <div className="space-y-6">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-lg font-semibold text-gray-900">
                  Review Your Application
                </h3>
                
                {!hasEditedOnce && (
                  <button
                    type="button"
                    onClick={handleEnableEdit}
                    className="px-4 py-2 rounded-lg border border-blue-600 text-blue-600 font-medium hover:bg-blue-50"
                  >
                    ✏️ Edit Application
                  </button>
                )}
              </div>

             

              <FormRenderer
                config={formConfig}
                initialValues={formValues}
                onSubmit={() => {}}
                nationality={nationality}
                portOfEntry={portOfEntry}
                portOfExit={portOfExit}
                previousNationalities={previousNationalities}
                otherNationalities={otherNationalities}
                country={country}
                mode="review"
                allowNavigation={true}
                uploadedDocuments={uploadedDocuments} // ✅ NEW PROP
                applicationId={applicationId} // ✅ NEW PROP
              />

             
              <div className="flex justify-end pt-6 border-t">
                <button
                  type="button"
                  onClick={() => setCurrentStep("submit")} // ✅ Go to step 6, not final submit
                  disabled={isSaving}
                  className="px-8 py-3 rounded-xl bg-green-600 text-white font-semibold hover:bg-green-700 shadow-lg disabled:bg-gray-300"
                >
                  Proceed to Submit
                </button>
              </div>
            </div>
          )} */}

          {/* STEP 5: REVIEW */}
          {currentStep === "review" && (
            <div className="space-y-6">
              <div className="flex justify-between items-center mb-6">
                <h3 className="text-lg font-semibold text-gray-900">
                  Review Your Application
                </h3>

                {!hasEditedOnce && (
                  <button
                    type="button"
                    onClick={handleEnableEdit}
                    className="px-4 py-2 rounded-lg border border-blue-600 text-blue-600 font-medium hover:bg-blue-50"
                  >
                    ✏️ Edit Application
                  </button>
                )}
              </div>

              {isLoadingConfig ? (
                <div className="flex items-center justify-center py-12">
                  <div className="text-gray-600">Loading form configuration...</div>
                </div>
              ) : !formConfig ? (
                <div className="flex items-center justify-center py-12">
                  <div className="text-red-600">Unable to load form configuration</div>
                </div>
              ) : (
                <FormRenderer
                  config={formConfig}
                  initialValues={formValues}
                  onSubmit={() => { }}
                  nationality={nationality}
                  portOfEntry={portOfEntry}
                  portOfExit={portOfExit}
                  previousNationalities={previousNationalities}
                  otherNationalities={otherNationalities}
                  country={country}
                  mode="review"
                  allowNavigation={true}
                  uploadedDocuments={uploadedDocuments}
                  applicationId={applicationId}
                />
              )}

              <div className="flex justify-end pt-6 border-t">
                <button
                  type="button"
                  onClick={() => setCurrentStep("submit")}
                  disabled={isSaving || !formConfig}
                  className="px-8 py-3 rounded-xl bg-green-600 text-white font-semibold hover:bg-green-700 shadow-lg disabled:bg-gray-300"
                >
                  Proceed to Submit
                </button>
              </div>
            </div>
          )}

          {/* STEP 6: FINAL SUBMISSION SUMMARY */}
          {currentStep === "submit" && (
            <div className="space-y-6">
              <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
                <div className="flex items-center gap-2">
                  <CheckCircle2 className="w-5 h-5 text-green-600" />
                  <p className="text-sm text-green-800 font-medium">
                    Application Received, Pending for Review
                  </p>
                </div>
              </div>

              <h2 className="text-xl font-bold text-gray-900 mb-6">
                Review & Submit {numPassengers > 1 ? "All Applications" : "Application"}
              </h2>

              <div className="bg-white border border-gray-200 rounded-lg p-6 space-y-3">
                <h3 className="text-lg font-semibold text-gray-900 mb-4">
                  Passenger {currentPassengerIndex}: {passengerData.fullName || "N/A"}
                </h3>

                <div className="space-y-2 text-sm">
                  <p className="text-gray-700">
                    <span className="font-medium">Application ID:</span>{" "}
                    <span className="text-gray-900 font-mono">{applicationId}</span>
                  </p>

                  <p className="text-gray-700">
                    <span className="font-medium">Passport:</span>{" "}
                    <span className="text-gray-900">
                      {formValues.passport_number || "Not provided"}
                    </span>
                  </p>

                 
                </div>
              </div>

              <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                <label className="flex items-start gap-3 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={consentGiven}
                    onChange={(e) => setConsentGiven(e.target.checked)}
                    className="w-5 h-5 mt-0.5 text-blue-600 border-gray-300 rounded focus:ring-2 focus:ring-blue-500"
                  />
                  <span className="text-sm text-gray-800">
                    I hereby declare that all information provided for all passengers is true and correct to the best of my knowledge.
                  </span>
                </label>
              </div>

              <div className="flex items-center justify-between pt-6 border-t">
                <button
                  type="button"
                  onClick={() => setCurrentStep("review")}
                  className="px-6 py-3 rounded-xl border border-gray-300 text-gray-700 font-medium hover:bg-gray-50"
                >
                  Back
                </button>

                <button
                  type="button"
                  onClick={handleFinalApplicationSubmit}
                  disabled={!consentGiven || isSaving}
                  className={`px-8 py-3 rounded-xl font-semibold transition-all ${consentGiven && !isSaving
                    ? "bg-green-600 text-white hover:bg-green-700 shadow-lg"
                    : "bg-gray-300 text-gray-500 cursor-not-allowed"
                    }`}
                >
                  {isSaving ? "Submitting..." : `Submit ${numPassengers > 1 ? `All ${numPassengers} Applications` : "Application"}`}
                </button>
              </div>
            </div>
          )}

          {showLoader && (
            <AIMagicLoader
              isDone={loaderDone}
              extractedCount={extractedCount}
              onClose={() => setShowLoader(false)}
            />
          )}
        </div>
      </div>
    </UserLayout>
  );
}

export default CreateNewApplication;